import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";

import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import ButtonsActions from "views/utils/buttonsActions";
import {ReportProgrammingModel} from "./programming/ReportProgrammingModel";
import TopBarActions from "components/TopBarActions";
import TableProgramming from "./programming/TableProgramming";
import axiApi from "ApiCaller";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";
import FormProgramming from "./programming/FormProgramming";

const ReportProgramming = () => {
    const {t} = useTranslation("routes");
    const {t: _Tf} = useTranslation("forms");
    const {t: _Tt} = useTranslation("tables");

    const title = t("labels.programing");
    const bread = [
        {name: t("labels.reports"), url: "/reports", current: false},
        {name: t("labels.programing"), current: true},
    ];
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const [buttonsTB, setButtonsTB] = useState(new ButtonsActions());

    const paramsAlertDelete = {
        icon: "info",
        iconColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
        confirmButtonText: _Tf("labels.delete"),
        cancelButtonText: _Tf("labels.cancel"),
    };
    const AlertDelete = new SwalAlertChoice(paramsAlertDelete);

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShow, setItemsShow] = useState([]);
    const [item, setItem] = useState({...ReportProgrammingModel});
    const [showForm, setShowForm] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);

    const headersTable = [
        {name: _Tt("programming.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("programming.reportType"), attr: 1, direction: "asc", active: false},
        {name: _Tt("common.repeat"), attr: 2, direction: "asc", active: false},
        {name: _Tt("common.start") + " " + _Tt("notifications.date"), attr: 3, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.start_hour"), attr: 4, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.email"), attr: 5, direction: "asc", active: false, disabled: true},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = title;

        buttons.add.active = true;
        buttons.add.onClick = onClickAdd;
        buttons.add.disabled = false;

        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;

        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;

        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchProgrammings();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchProgrammings();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = ReportProgrammingModel;

        fetchGetProgrammings();
    }, []);

    filters.current.filter = () => fetchProgrammings();

    const fetchGetProgrammings = () => {
        setIsLoading(true);
        axiApi
            .get("/api/reports/programing/")
            .then((resp) => {
                if (resp.data) {
                    items.current.showed = [...resp.data.items];
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
                filters.current.list = {};
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchProgrammings = () => {
        setIsLoading(true);
        axiApi
            .post("/api/reports/programing/filter/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                if (resp.data) {
                    items.current.setShowed(resp.data.items);
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClickAdd = () => {
        setShowPrev(false);
        setItem({...ReportProgrammingModel});
        setShowForm(true);
    };
    const onClickEdit = () => {
        setShowPrev(false);
        setShowForm(true);
    };

    const onClickDelete = () => {
        AlertDelete.question(_Tf("delete.title"), `Se eliminaran los ${items.current.chosen.length} seleccionados`).then((r) => {
            if (r.isConfirmed) {
                let ids = items.current.getChosenIds();
                axiApi
                    .delete("/api/reports/programing/", {data: {ids: ids}})
                    .then((r) => {
                        if (r.data.status) {
                            Alert.success("Confirmado", "Se han eliminado correctamente");
                            items.current.showed = items.current.showed.filter((_item) => !ids.includes(_item.id));
                            items.current.clearChosen();
                            setItemsShow([...items.current.showed]);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />

            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableProgramming
                            itemsShow={itemsShow}
                            items={items}
                            checkAll={checkedAll}
                            setCheckAll={setCheckedAll}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                {/* {showPrev ? (
                    <div
                        className="col-md col-12 prev-item"
                        style={{maxWidth: "300px"}}>
                        <PrevProgramming show={showPrev} item={item}></PrevProgramming>
                    </div>
                ) : (
                    <></>
                )} */}
            </div>
            {showForm ? (
                <FormProgramming
                    item={item}
                    setItem={setItem}
                    items={items}
                    showForm={showForm}
                    setShowForm={setShowForm}
                    setItemsShow={setItemsShow}
                    fetchProgrammings={fetchProgrammings}
                />
            ) : (
                <></>
            )}
        </>
    );
};

export default ReportProgramming;
